import { allowListMessages } from 'src/features/parkingManagement/utils/allowListMessages';
import { ICON_MAP } from 'src/features/parkingStatus/utils';

import type { BadgeOptions } from 'src/types';

export enum ALLOW_LIST_TYPE {
    WHITELIST = 'whitelist',
    BLACKLIST = 'blacklist',
}

export enum ALLOW_LIST_PURPOSE {
    RESERVATION = 'reservation',
    SUBSCRIPTION = 'subscription',
    EV = 'ev',
    ENTRANCE = 'entrance',
}

export const ALLOW_LIST_TYPE_TRANSLATION_MAP = {
    [ALLOW_LIST_TYPE.WHITELIST]: allowListMessages.whitelist,
    [ALLOW_LIST_TYPE.BLACKLIST]: allowListMessages.blacklist,
};

export const ALLOW_LIST_PURPOSE_TRANSLATION_MAP = {
    [ALLOW_LIST_PURPOSE.RESERVATION]: allowListMessages.reservation,
    [ALLOW_LIST_PURPOSE.SUBSCRIPTION]: allowListMessages.subscription,
    [ALLOW_LIST_PURPOSE.EV]: allowListMessages.ev,
    [ALLOW_LIST_PURPOSE.ENTRANCE]: allowListMessages.entrance,
};

export type AllowList = {
    id: string;
    name: string;
    type: ALLOW_LIST_TYPE;
    purposes: ALLOW_LIST_PURPOSE[];
};

export type AllowListMember = {
    id: string;
    identifier: string;
    name: string;
    email?: string;
};

export const allowListTypeBadgeOptions: BadgeOptions = {
    [ALLOW_LIST_TYPE.WHITELIST]: {
        label: allowListMessages.whitelist,
        icon: ICON_MAP.LIST,
        theme: 'white',
    },
    [ALLOW_LIST_TYPE.BLACKLIST]: {
        label: allowListMessages.blacklist,
        icon: ICON_MAP.LIST,
        theme: 'gray',
    },
};
